import Vue from "vue";
Vue.directive("debounce", {
  // 指令第一次绑定到元素时
  bind: function(el, binding) {
    let wait = binding.value || 1000; // 防抖时间, 用户若不设置防抖时间，则默认1s
    let timer;
    el.addEventListener(
      "click",
      (event) => {
        console.log("debounce");

        if (!timer) {
          // 第一次执行: 不阻止click⌚️
          timer = setTimeout(() => {
            timer = null;
          }, wait);
        } else {
          clearTimeout(timer);
          timer = setTimeout(() => {
            timer = null;
          }, wait);
          event && event.stopImmediatePropagation();
        }
      },
      true
    );
  },
});
